import { Stack, Typography } from '@mui/material'

import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type PaymentInfoCellProps = {
  isKonbini: boolean
}

export const PaymentInfoCell: Cell<PaymentInfoCellProps> = ({ isKonbini }) => {
  const { t } = useTranslation('consoleLotteryManagementDetail')

  return (
    <CellFrame>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        py={3}
      >
        <Typography variant="h5" color="text.secondary">
          {t('paymentInfoHead', '支払い情報')}
        </Typography>
      </Stack>
      <Stack sx={{ bgcolor: 'grey.50', p: 5, borderRadius: 2 }}>
        <Typography variant="h5">
          {isKonbini ? t('convenienceStore') : t('creditCard')}
        </Typography>
      </Stack>
    </CellFrame>
  )
}
